import { render, staticRenderFns } from "./viewAdditionItem.vue?vue&type=template&id=af5b1adc&scoped=true&"
import script from "./viewAdditionItem.vue?vue&type=script&lang=ts&"
export * from "./viewAdditionItem.vue?vue&type=script&lang=ts&"
import style0 from "./viewAdditionItem.vue?vue&type=style&index=0&id=af5b1adc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5b1adc",
  null
  
)

export default component.exports